import ProjectServiceContainer from "./ProjectServiceContainer";

export default ProjectServiceContainer;
